<div class="container">
  <!-- Title -->
  <div class="text-center">
    <strong class="mainHeading">Price Configuration</strong>
  </div>

  <!-- Buttons Section -->
  <div class="d-flex justify-content-between mt-2">
    <div class="d-flex gap-3">
      <!-- New Button: Trigger to open/close the modal -->
      <!-- <button class="btn btn-success" (click)="openModal(createModal)">
        <i class="bi bi-file-earmark-plus me-1 mt-1"></i> New
      </button> -->
      <button class="btn btn-outline-primary me-2" ngbTooltip="Export">
        <i class="bi bi-box-arrow-right me-2" (click)="exportToExcel()"></i>
        Export
      </button>
      <!-- <button class="btn btn-outline-secondary me-2" ngbTooltip="Print">
      <i class="bi bi-printer me-2"></i> Print
    </button> -->
      <button class="btn btn-outline-danger" ngbTooltip="Clear Filter" (click)="clearFilter()">
        <i class="bi bi-x-circle me-2"></i> Clear Filter
      </button>
    </div>
    <div class="d-flex align-items-center gap-2">
      <label for="typeOfUser" class="mb-0">Select City</label>
      <select (change)="onFilterCityChange($event)" class="form-select w-auto">
        <option value="all">All</option>
        <option *ngFor="let city of cityList" [value]="city.id">{{ city.cityName }}</option>
      </select>
    </div>
  </div>

  <!-- Table -->
  <div class="card shadow-lg p-4 mt-3">
    <div class="table-responsive">
      <table class="table table-bordered table-striped">
        <thead class="table-warning text-center">
          <tr>
            <!-- <th>Container ID</th> -->
            <th>City</th>
            <th>
              Container Type
              <div class="dropdown d-inline-block">
                <i class="bi bi-funnel dropdown-toggle" data-bs-toggle="dropdown" (click)="toggleFilter('name')"></i>
                <ul class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" (click)="clearFilter()">All</a>
                  </li>
                  <li *ngFor="let name of uniqueContainerNames">
                    <a class="dropdown-item" (click)="filterContainerName = name; applyFilters()">{{ name }}</a>
                  </li>
                </ul>
              </div>
            </th>
            <th>
              Container Capacity (m³)
              <div class="dropdown d-inline-block">
                <i class="bi bi-funnel dropdown-toggle" data-bs-toggle="dropdown"
                  (click)="toggleFilter('capacity')"></i>
                <ul class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" (click)="clearFilter()">All</a>
                  </li>
                  <li *ngFor="let capacity of uniqueContainerCapacities" [value]="capacity">
                    <a class="dropdown-item" (click)="
                        filterContainerCapacity = capacity; applyFilters()
                      ">{{ capacity }}</a>
                  </li>
                </ul>
              </div>
            </th>
            <th>Container Rental Charges per Week (SAR)</th>
            <th>Trip Charges per KM (SAR)</th>
            <th>Disposal Charges per Trip (SAR)</th>
            <!-- <th>Action</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of pagedData; let i = index">
            <!-- <td class="text-center">{{ item.id }}</td> -->
            <td class="text-center">{{ item.cityName }}</td>
            <td class="text-center">{{ item.containerName }}</td>
            <td class="text-center">{{ item.containerExactCapacity }}</td>
            <td class="text-center">{{ item.containerRent }}</td>
            <td class="text-center">{{ item.tripChrages }}</td>
            <td class="text-center">{{ item.disposalCharges }}</td>
            <!-- <td class="text-center">
              <i class="bi bi-plus-square text-danger" style="cursor: pointer"
                (click)="editItem(item, createModal)"></i>
            </td> -->
          </tr>
          <tr *ngIf="priceListContainer?.length === 0">
            <td colspan="10" class="text-center">No Data Found</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-3">
      <!-- Pagination Centered -->
      <div class="d-flex justify-content-center flex-grow-1">
        <ngb-pagination *ngIf="priceListContainer?.length > 0" [(page)]="page" [pageSize]="pageSize"
          [collectionSize]="priceListContainer?.length" (pageChange)="onPageChange($event)" [boundaryLinks]="true">
        </ngb-pagination>
      </div>

      <!-- Entries Message Aligned to the End -->
      <div *ngIf="priceListContainer?.length > 0" class="text-muted mb-3">
        <strong>Showing {{ (page - 1) * pageSize + 1 }} to {{ (page * pageSize) > priceListContainer?.length ?
          priceListContainer?.length
          :page *pageSize }} of {{ priceListContainer?.length }} entries</strong>
      </div>
    </div>
  </div>

  <!-- Modal for Create/Edit -->
  <ng-template #createModal let-modal>
    <div class="modal-header custom-modal-header">
      <h2 class="modal-title mt-2">
        {{
        isEditMode ? "Edit Price Configuration" : "New Price Configuration"
        }}
      </h2>
      <button type="button" class="btn-close" style="background-color: white !important" aria-label="Close"
        (click)="modal.dismiss()"></button>
    </div>
    <form [formGroup]="priceConfigureForm">
      <div class="modal-body">
        <div class="col-md-4">
          <label for="typeOfUser">Select City</label>
          <select formControlName="cityId" (change)="onCityChange($event)" class="form-select" [ngClass]="{
            'invalid-field':
            priceConfigureForm.controls['cityId'].invalid &&
            priceConfigureForm.controls['cityId'].touched
          }">
            <option value="" disabled selected>Select City</option>
            <option *ngFor="let city of cityList" [value]="city.id">{{ city.cityName }}</option>
          </select>
        </div>
        <!-- Container Hiring Charges -->
        <div class="text-white p-2 mt-2" style="background-color: #8e0e00">
          Container Rental Charges
        </div>
        <!-- Container Type and Capacity -->
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label w-100 text-start">Container Type</label>
            <select class="form-select w-100" formControlName="containerName" (change)="onContainerChange($event)"
              [disabled]="isEditMode" [ngClass]="{
                'invalid-field':
                  priceConfigureForm.controls['containerName'].invalid &&
                  priceConfigureForm.controls['containerName'].touched
              }">
              <option value="" disabled selected>Select Container Type</option>
              <option *ngFor="let containerName of allContainerName" [value]="containerName">
                {{ containerName }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label w-100 text-start">Container Capacity</label>
            <select class="form-select w-100" formControlName="containerCapacity"
              (change)="onContainerCapacityChange($event)" [ngClass]="{
                'invalid-field':
                  priceConfigureForm.controls['containerCapacity'].invalid &&
                  priceConfigureForm.controls['containerCapacity'].touched
              }">
              <option value="" disabled selected>
                Select Container Capacity
              </option>
              <option *ngFor="let capacity of allContainerCapacity" [value]="capacity">
                {{ capacity }}
              </option>
            </select>
          </div>
        </div>

        <!-- Container Charges -->
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-2">Container Charges (Rent Per Week)</label>
          <input type="number" class="form-control" style="width: 125px" formControlName="containerCharges" [ngClass]="{
              'invalid-field':
                priceConfigureForm.controls['containerCharges'].invalid &&
                priceConfigureForm.controls['containerCharges'].touched
            }" />
        </div>

        <!-- Trip Charges -->
        <div class="text-white p-2 mb-3" style="background-color: #8e0e00">
          Trip Charges
        </div>
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label w-100 text-start">Container Type</label>
            <input type="text" class="form-control w-100" [value]="priceConfigureForm.get('containerName')?.value"
              formControlName="disposalContainerName" />
          </div>
          <div class="col-md-6">
            <label class="form-label w-100 text-start">Container Capacity</label>
            <input type="text" class="form-control w-100" [value]="priceConfigureForm.get('containerCapacity')?.value"
              formControlName="disposalContainerCapacity" />
          </div>
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-2">Trip Charges (Per KM)</label>
          <input type="number" class="form-control" style="width: 125px" formControlName="tripCharges" [ngClass]="{
              'invalid-field':
                priceConfigureForm.controls['tripCharges'].invalid &&
                priceConfigureForm.controls['tripCharges'].touched
            }" />
        </div>

        <!-- Disposal Charges -->
        <div class="text-white p-2 mb-3" style="background-color: #8e0e00">
          Disposal Charges
        </div>
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label w-100 text-start">Container Type</label>
            <input type="text" class="form-control w-100" [value]="priceConfigureForm.get('containerName')?.value"
              formControlName="disposalContainerName" />
          </div>
          <div class="col-md-6">
            <label class="form-label w-100 text-start">Container Capacity</label>
            <input type="text" class="form-control w-100" [value]="priceConfigureForm.get('containerCapacity')?.value"
              formControlName="disposalContainerCapacity" />
          </div>
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-2">Disposal Charges (Per Trip)</label>
          <input type="number" class="form-control" style="width: 125px" formControlName="disposalCharges" [ngClass]="{
              'invalid-field':
                priceConfigureForm.controls['disposalCharges'].invalid &&
                priceConfigureForm.controls['disposalCharges'].touched
            }" />
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="onSubmit(modal, isEditMode ? 'edit' : 'new')">
          {{ isEditMode ? "Save Changes" : "Submit" }}
        </button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
          Cancel
        </button>
      </div>
    </form>
  </ng-template>
</div>